<template>
  <v-container>
    <v-card id="contact-details">
<!--      <v-breadcrumbs :items="quote.versions">
         <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
        :href="item"
      >
        {{ item.toUpperCase() }}
      </v-breadcrumbs-item>
      </template>
      </v-breadcrumbs>
-->
      <v-card-title> Στοιχεία Πελάτη </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          :valid="valid"
        >
        <v-row>
          <v-col cols=12 sm=4 md=2>
          <v-text-field
          label="Μοναδικός Αριθμός Προσφοράς"
          v-model="quote.quote_id"
          prepend-icon="mdi-counter"
            >
          </v-text-field>
          </v-col>
          <v-col cols=12 sm=2 md=2>
          <v-select
          label="Έκδοση"
          v-model="version"
          :items="quote.versions"
          prepend-icon="mdi-git"
          @change="switchVersion"
            >
          </v-select>
          </v-col>
          <v-col cols=12 sm=4 md=3>
              <v-menu
              v-model="dateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
              :disabled="isdisabled"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="quote.qdate"
                  label="Ημερομηνία"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="quote.qdate"
                @input="dateMenu = false"
                min="2016-01-01"
                :max="
                  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10)
                "
              ></v-date-picker>
            </v-menu>
          </v-col>
            <v-col cols=12 sm=4 md=3>
          <v-text-field
            v-model="quote.vehicle"
            prepend-icon="mdi-truck"
            :rules="[(v) => !!v || 'Customer is required']"
            label="Όχημα"
            >
          </v-text-field>
          </v-col>
        </v-row>
          <v-row>
          <v-col cols=6>
        <v-text-field
          v-model="quote.customer.Name"
          persistent-hint
          :hint="quote.customer.Cid"
          readonly
          label="Πελάτης"
          prepend-icon="mdi-badge-account"
          >
          </v-text-field>
          </v-col>
          </v-row>
          <v-row>
          <v-col cols=6>
          <v-text-field
            v-model="quote.recipient"
            prepend-icon="mdi-account"
            label="Παραλήπτης"
            >
          </v-text-field>
          </v-col>
          </v-row>
          <v-row>
          <v-col cols=12 md=6>
          <v-textarea
            v-model="quote.notes"
            prepend-icon="mdi-notebook"
            rows="1"
            :auto-grow=true
            label="Σημειώσεις"
            hint="Αριθμός πλαισίου, όχημα, κλπ"
            >
         </v-textarea>
          </v-col>
          </v-row>
          <v-row>
          <v-col cols=6>
          <v-text-field
            v-model="margin"
            prepend-icon="mdi-cash"
            label="Προσαυξηση"
            >
          </v-text-field>
          <v-col cols=6>
          <v-text-field
            v-model="dscnt"
            prepend-icon="mdi-cash"
            label="Εκπτωση"
            >
          </v-text-field>
          </v-col>
          </v-col>
          <v-col>
          <v-checkbox
            v-model="roundParts"
            prepend-icon="mdi-cash"
            label="Στρογγ."
            >
          </v-checkbox>

          </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
      <v-speed-dial
      v-model="fab"
      top
      right
      direction="left"
      absolute
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          color="blue darken-2"
          dark
          fab
        >
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
            <v-btn
              color="primary"
              fab
              class="ml-2 white--text"
              v-if="isWeb"
              @click="genQuotes('.pdf')"
              >
              <v-icon dark>mdi-file-pdf-box</v-icon>
            </v-btn>
             <v-btn
              color="primary"
              fab
              class="ml-2 white--text"
              target="_blank"
              :href="pdfPath"
              v-if="!isWeb"
              >
              <v-icon dark>mdi-file-pdf-box</v-icon>
            </v-btn>
            <v-btn
              fab
              color="primary"
              class="ml-2 white--text"
              @click="genQuotes('.docx')"
              >
              <v-icon dark>mdi-file-word</v-icon>
            </v-btn>
            <v-btn
              fab
              color="primary"
              :disabled="!savePending"
              class="ml-2 white--text"
              @click="saveQuote">
              <v-icon dark>mdi-content-save</v-icon>
            </v-btn>
            <v-btn
              fab
              color="primary"
              class="ml-2 white--text"
              @click="unlockQuote">
              <v-icon v-if="isdisabled" dark>mdi-lock-open</v-icon>
              <v-icon v-else dark>mdi-lock</v-icon>
            </v-btn>
             <v-btn
              v-if="!quote.committed"
              fab
              color="primary"
              class="ml-2 white--text"
              @click="commitQuote">
              <v-icon dark>mdi-source-branch</v-icon>
            </v-btn>
            <v-btn
              fab
              color="primary"
              class="ml-2 white--text"
              @click="duplicateQuote">
              <v-icon dark>mdi-content-copy</v-icon>
            </v-btn>
        </v-speed-dial>
        <v-menu
          v-model="sendMenu"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-send</v-icon> Αποστολη
        </v-btn>
      </template>

      <v-card min-width="300">
            <v-card-title> Αποστολή μέσω e-mail </v-card-title>
       <v-list>
          <v-list-item>
            <v-text-field
              v-model="recipient"
              label="Παραλήπτης"
            ></v-text-field>
          </v-list-item>
        </v-list>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            variant="text"
            @click="sendMenu = false"
          >
            Ακυρωση
          </v-btn>
          <v-btn
            color="primary"
            variant="text"
            :disabled="sendingQuote"
            @click="sendQuote()"
          >
            <span v-if="!sendingQuote">Αποστολη</span>
            <v-progress-circular v-if="sendingQuote" color="primary" indeterminate :size="24" :width="4"></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
      </v-card-actions>
    </v-card>

    <v-card class="mx-auto mt-10" id="item-list" >
      <v-card-title>Λίστα ανταλλακτικών</v-card-title>
      <v-card-text>
      <v-data-table
        :headers="headers"
        :items="lineItems"
        item-key="id"
        :search="search"
        :item-class="rowClass"
        class="elevation-0"
        height="600px"
        v-sortable-data-table
        @sorted="saveOrder"
        fixed-header>

        <v-divider inset></v-divider>
        <template v-slot:top>
          <v-toolbar flat height="120px" color="white">
            <div class="d-flex w-200">
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" dense outlined single-line hide-details></v-text-field>
              <v-btn
                color="primary"
                class="ml-2 white--text"
                :disabled="isdisabled"
                @click="addNew">
                <v-icon dark>mdi-plus</v-icon>Προσθήκη
              </v-btn>

               <v-dialog
                v-model="dialogAddPart"
                persistent
                max-width="800px"
              >
                <template v-slot:activator="{on, attrs}">
                    <v-btn
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      class="ml-2 white--text">
                      <v-icon dark>mdi-plus</v-icon>Ανταλλακτικό
                    </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">Εισαγωγη</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="invoice">
                    <v-container>
                      <v-row>

                      <v-col cols="4" sm="4" md=4>
                          <v-text-field
                            label="Ποσότητα*"
                            :rules="[rules.required, rules.qty]"
                            v-model.number="partQty"
                            required
                            persistent-hint
                            ></v-text-field>

                      </v-col>
                       <v-col cols="12" sm="8" md=6>
    <v-autocomplete
      v-model="order"
      :items="parts"
      hide-no-data
      :filter="customFilter"
      return-object
      :hint="`${order.FmSku} - ${order.FmSku}`"
      persistent-hint
      label="Ανταλλακτικό"
    >
    <template v-slot:selection="data">
                  {{ data.item.FmSku }} - {{ data.item.Description }}
              </template>
              <template v-slot:item="{ item }">
                <template v-if="typeof item !== 'object'">
                  <v-list-item-content v-text="item"></v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.FmSku }} - Κωδ. {{ item.Id }} </v-list-item-title>
                    <v-list-item-subtitle>{{ item.Description }} {{ item.Remarks }} </v-list-item-subtitle>
                    <v-list-item-subtitle>Τιμή: {{ tocurr(item.RetailPrice) }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </template>
    </v-autocomplete>
    </v-col>
                      </v-row>
                    </v-container>
                    <small>*indicates required field</small>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="dialogAddPart = false"
                    >
                      Κλείσιμο
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="savePart"
                    >
                      Αποθήκευση
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

            <v-btn
                v-if=false
                color="primary"
                class="ml-2 white--text"
                >
                <v-icon dark>mdi-plus</v-icon>Εργασια
            </v-btn>

            <v-dialog
                v-model="dialog2"
                persistent
                max-width="800px"
              >
                <template v-slot:activator="{on, attrs}">
                    <v-btn
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      class="ml-2 white--text">
                      <v-icon dark>mdi-plus</v-icon>Εργασια
                    </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">Εισαγωγη</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="service">
                    <v-container>
                      <v-row>

                      <v-col cols="4" sm="4" md=4>
                          <v-text-field
                            label="Ποσότητα*"
                            :rules="[rules.required]"
                            v-model.number="service.Qty"
                            required
                            persistent-hint
                            ></v-text-field>

                      </v-col>
                       <v-col cols="12" sm="8" md=6>
    <v-combobox
      v-model="service"
      :items="$services"
      hide-no-data
      :filter="customServiceFilter"
      return-object
      cache-items
      :hint="`${service.FmSku} - ${service.Description}`"
      label="Εργασία"
      @change="onServiceChange"
    >
    <template v-slot:selection="data">
                  {{ data.item.FmSku }} - {{ data.item.Description }}
              </template>
              <template v-slot:item="{ item }">
                <template v-if="typeof item !== 'object'">
                  <v-list-item-content v-text="item"></v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.Description }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.FmSku }} - {{ tocurr(item.Price) }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </template>

    </v-combobox>

    </v-col>
    <v-col>
          <v-text-field
            label="Τιμή*"
            :rules="[rules.required]"
            v-model="service.Price"
            type="number"
            dense
            required
            ></v-text-field>
                      </v-col>
                      </v-row>
                    </v-container>
                    <small>*indicates required field</small>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="dialog2 = false"
                    >
                      Κλείσιμο
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="saveService"
                    >
                      Αποθήκευση
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>


            </div>
              <v-spacer/>
          <v-select
            v-model="template"
            :items="templates"
            :item-text="`{template.split('/')[-1]}`"
            single-line
            prepend-icon="mdi-format-textbox"
            dense
            @change="updateItems"
            label="Πρότυπο"
            >
            </v-select>
              <v-spacer/>
        <div class="text-right py-10 ma-5">
          <p><b>Σύνολο:</b>&nbsp; <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
        >{{ tocurr(net) }}</span>
      </template>
      <span>Ανταλλακτικά: {{ tocurr(netItems) }}, Εργασία: {{ tocurr(netService) }} </span>
    </v-tooltip></p>
          <p><b>ΦΠΑ 24%:</b>&nbsp; {{ tocurr(vat) }}</p>
          <p><b>Γενικό Σύνολο:</b>&nbsp; {{ tocurr(total) }}</p>
        </div>
            </v-toolbar>
        </template>
        <template v-slot:item.index="{ item }">
            <v-icon class="rowHandle">
              mdi-drag-vertical
            </v-icon>
          <span>{{lineItems.indexOf(item)+1}}</span>
        </template>
        <template v-slot:item.sku="{ item }">
          <v-text-field v-model="editedItem.sku" :hide-details="true" dense single-line v-if="item.id === editedItem.id"></v-text-field>
          <span v-else>{{item.sku}}</span>
        </template>
        <template v-slot:item.description="{ item }">
          <v-text-field v-model="editedItem.description" :hide-details="true" dense single-line v-if="item.id === editedItem.id"></v-text-field>
          <span v-else>{{item.description}}</span>
        </template>
        <template v-slot:item.qty="{ item }">
          <v-text-field v-model="editedItem.qty" :hide-details="true" dense single-line v-if="item.id === editedItem.id"></v-text-field>
          <span v-else>{{item.qty}}</span>
        </template>
        <template v-slot:item.price="{ item }">
          <v-text-field v-model.number="editedItem.price" :hide-details="true" dense single-line v-if="item.id === editedItem.id"></v-text-field>
          <span v-else-if='!template.startsWith("RIGAS")'>{{tocurr(item.price*factor(item))}}</span>
          <span v-else>{{tocurr(item.price)}}</span>
        </template>
        <template v-slot:item.unit="{ item }">
          <v-select v-model="editedItem.unit" :items="['ΤΕΜ', 'ΣΕΤ', 'ΚΙΛΑ', 'ΛΙΤΡΑ', 'ΜΕΤΡΑ', 'ΤΕΤ. ΜΕΤΡΑ', 'ΚΥΒΙΚΑ', 'ΚΙΒΩΤΙΑ', '']" :hide-details="true" dense single-line v-if="item.id === editedItem.id"></v-select>
          <span v-else>{{item.unit}}</span>
        </template>
        <template v-slot:item.kind="{ item }">
          <v-select v-model="editedItem.kind" :items="['part', 'service']" :hide-details="true" dense single-line v-if="item.id === editedItem.id"></v-select>
          <span v-else>{{item.kind}}</span>
        </template>
        <template v-slot:item.vat="{ item }">
          <span v-if="isNaN(item.price)"></span>
            <span v-else>{{ tocurr(item.qty*factor(item)*item.price*0.24)}}</span>
        </template>
        <template v-slot:item.gross="{ item }">
          <span v-if="isNaN(item.price)"></span>
            <span v-else>{{ tocurr(item.qty*factor(item)*item.price)}}</span>
        </template>
        <template v-slot:item.value="{ item }">
          <span v-if="isNaN(item.price)"></span>
            <span v-else>{{ tocurr(item.qty*factor(item)*item.price*1.24)}}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <div v-if="item.id === editedItem.id">
            <v-icon color="error" class="mr-3" @click="close">
              mdi-window-close
            </v-icon>
            <v-icon color="primary" @click="save">
              mdi-content-save
            </v-icon>
          </div>
          <div v-else>
            <v-icon class="mr-3" :disabled="isdisabled" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon class="mr-3" :disabled="isdisabled" @click="copyItem(item)">
              mdi-content-copy
            </v-icon>
             <v-icon class="mr-3" :disabled="isdisabled" @click="addAlt(item)">
              mdi-content-duplicate
            </v-icon>
            <v-icon :disabled="isdisabled"  @click="deleteItem(item)">
              mdi-delete
            </v-icon>
          </div>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      </v-card-text>
    </v-card>
      <v-snackbar
   timeout=2500
   v-model="snackbar">
      {{ snackText }}
  </v-snackbar>
     <v-dialog
                v-model="dialog"
                persistent
                max-width="800px"
              >
               <v-card>
                  <v-card-title>
                    <span class="text-h5">Εναλλακτικό ανταλλακτικό</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="altRef">
                    <v-container>
                      <v-row>

                      <v-col>
                          <v-text-field
                            label="Εναλλακτική Περιγραφή*"
                            v-model="editedItem.alt.descr"
                            required
                            ></v-text-field>

                      </v-col>
                       <v-col>
                          <v-text-field
                            label="Εναλλακτικό SKU*"
                            v-model="editedItem.alt.sku"
                            required
                            ></v-text-field>

                      </v-col>
                       <v-col>
                          <v-text-field
                            label="Εναλλακτική Τιμή*"
                            v-model.number="editedItem.alt.price"
                            required
                            ></v-text-field>

                      </v-col>
                      </v-row>
                    </v-container>
                    <small>*indicates required field</small>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="close"
                    >
                      Κλείσιμο
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="save"
                    >
                      Αποθήκευση
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
  </v-container>
</template>

<script>

var seedrandom = require('seedrandom');
import filter from "lodash/filter";
import cloneDeep from "lodash/cloneDeep";
import { Capacitor } from "@capacitor/core"

import Sortable from 'sortablejs';


export default {
  props: {
    //lineItems: []
  },
  computed: {
    net () {
      return this.sumFactoredTotals(this.lineItems);
    },
    netItems () {
      return this.sumFactoredTotals(this.lineItems.filter(e=>e.kind=="part"));
    },
    netService () {
      return this.sumFactoredTotals(this.lineItems.filter(e=>e.kind=="service"));
    },
    vat () {
      return this.net * 0.24;
    },
    total () {
      return this.net + this.vat;
    },
    pdfPath () {
        return this.$api.defaults.baseURL + "/quotes/pdf/" + this.version;
    },
    isdisabled () {
      return this.quote.committed && this.lockedQuote;
    },
    isWeb () {
        return Capacitor.getPlatform() === 'web';
    }
  },

  data () {
    return {
    dateMenu: false,
    dialog: false,
    dialog2: false,
    dialogAddPart: false,
    fab: false,
    valid: true,
    version: '',
    search: '',
    margin: 0,
    dscnt: 0,
    savePending: false,
    service: {
          FmSku: "030",
          Description: "ΕΞΑΓΩΓΗ ΚΑΙ ΑΝΤΙΚΑΤΑΣΤΑΣΗ ΑΝΤΑΛΛΑΚΤΙΚΩΝ",
          Price: 0,
          Qty: 1,
        },
    snackbar: false,
    snackText: "",
    sendingQuote: false,
    template: "RIGAS-FM",
    templates: [],
    lockedQuote: true,
    sendMenu: false,
    recipient: "",
    order: {StockQty:0},
    partQty: 1,
    partTechId: 1,
    parts: [],
    roundParts: false,
    rules: {
        required: value => !!value || 'Required.',
        qty: value => value <= this.order.StockQty || 'Out of stock!',
        limit: value => value <= this.editedItem.Limit || 'Τιμή κάτω του κόστους'

    },
    rng: seedrandom(this.$route.params.quoteid),
    factors: Array.from({length: 20}, () => 1 ),
    quote: {customer: '', vehicle: '', recipient: '', quote_id:'', qdate: ''},
    headers: [
      {
        text: 'A/A',
        value: 'index',
        sortable: false,
        width: '5%'
      },
      {
        text: 'Κωδικός',
        value: 'sku',
        sortable: false,
        width: '15%'
      },
      {
        text: 'Περιγραφή',
        value: 'description',
        sortable: false,
        width: '35%'
      },
      {
        text: 'Ποσότητα',
        value: 'qty',
        sortable: false,
        width: '5%'
      },
      {
        text: 'Μονάδα',
        value: 'unit',
        sortable: false,
        width: '8%'
      },
      {
        text: 'Τιμή',
        value: 'price',
        sortable: false
      },
      {
        text: 'Καθ. Αξία',
        value: 'gross',
        sortable: false
      },
      {
        text: 'ΦΠΑ',
        value: 'vat',
        sortable: false
      },
      {
        text: 'Αξία',
        value: 'value',
        sortable: false
      },
      {
        text: 'ΤΥΠΟΣ',
        value: 'kind',
        sortable: false,
        width: '5%',
      },
      { text: 'Actions', value: 'actions', sortable: false , width: "190px"},
    ],
    lineItems: [],
    editedIndex: -1,
    editedItem: {
      id: 0,
      sku: '000-0000',
      description: '',
      qty: 0,
      unit: 'TEM',
      price: 0,
      kind: 'part',
      alt: {
       descr: '',
       price: 0,
       sku: ''
      },
    },
    altItem: {
       descr: '',
       price: 0,
       sku: ''
    },
    defaultItem: {
      id: 0,
      sku: '000-0000',
      description: '',
      qty: 1,
      unit: 'ΤΕΜ',
      price: 0,
      kind: 'part',
      alt: {
       descr: '',
       price: 0,
       sku: ''
      },
    }
    }
  },
   mounted() {
        this._keyListener = function(e) {
            if (e.key === "s" && (e.ctrlKey || e.metaKey)) {
                e.preventDefault(); // prevent "Save Page" from getting triggered.

                this.saveQuote();
            }
        };

        document.addEventListener('keydown', this._keyListener.bind(this));
    },
  beforeDestroy() {
        document.removeEventListener('keydown', this._keyListener);
  },
  beforeRouteLeave () {
    if (this.savePending) {
        const answer = window.confirm('Είστε σίγουροι πως θέλετε να φύγεται; Δεν έχει σώσει τις αλλαγές!')
        if (!answer) return false;
    }
    
  },
  async created () {
      this.initialize();
      let res = await this.$api.get("/quotes/templates", {cache: {maxAge: 2*60*1000}});
      this.templates = res.data;
  },
  directives: {
    sortableDataTable: {
      bind(el, binding, vnode) {
        const options = {
          handle: ".rowHandle",
          animation: 150,
          onUpdate: function(event) {
            vnode.child.$emit('sorted', event);
          },
        };
        Sortable.create(el.getElementsByTagName('tbody')[0], options);
      },
    },
  },
  methods: {
    roundUpNearest10(num) {
      return Math.ceil(num / 10) * 10;
    },
    roundUpNearest50or100(num) {
      let nearest_five =  Math.ceil(num*100/5) * 5
      // let nearest_ten =  Math.ceil(num / 10) * 10;
      let nearest_floor =  Math.floor(num) *10;
      // if the number is closer to next 5 or 10 return the nearest 5 or 10
      if (Math.abs(nearest_five - num) < Math.abs(nearest_floor-num)) return nearest_five
      // else return the nearest floor
      return nearest_floor
    },
    roundUpNearestPoint(num) {
      if (num > 100) {
        let nearest_five =  Math.ceil(num/5);
        // let nearest_ten =  Math.ceil(num / 10) * 10;
        let nearest_floor =  Math.floor(num);
        // if the number is closer to next 5 or 10 return the nearest 5 or 10
        if (Math.abs(nearest_five - num) < Math.abs(nearest_floor-num)) return nearest_five
        // else return the nearest floor
        return nearest_floor
      } else {
        let nearest_five =  Math.ceil(num*10/5) * 50/10
        // let nearest_ten =  Math.ceil(num / 10) * 10;
        let nearest_floor =  Math.floor(num*10) / 10 ;
        // if the number is closer to next 5 or 10 return the nearest 5 or 10
        if (Math.abs(nearest_five - num) < Math.abs(nearest_floor-num)) return nearest_five
        // else return the nearest floor
        return nearest_floor
      }

    },
    roundUpNearest5or10(num) {
      let nearest_five =  Math.ceil(num/5) * 5
      // let nearest_ten =  Math.ceil(num / 10) * 10;
      let nearest_floor =  Math.floor(num/10) *10;
      // if the number is closer to next 5 or 10 return the nearest 5 or 10
      if (Math.abs(nearest_five - num) < Math.abs(nearest_floor-num)) return nearest_five
      // else return the nearest floor
      return nearest_floor
    },
    rowClass (item) {
      return this.lineItems.indexOf(item) %2 ? 'blue-grey lighten-5' : 'white darken-2';
    },
    sumFactoredTotals(arr) {
      // sum data in give key (property)
      return arr.reduce((a, b) => a + (b.price*this.factor(b)*b.qty || 0), 0);
    },
    onServiceChange(entry) {
      if (typeof entry === 'string' && entry.trim()) {
        const item = this.$services.find(item => item.Description === entry)
        if (item) {
          this.service = item
        } else {
          this.service = this.addItem(entry)
        }
      }
    },
    async switchVersion(newVal) {

      const response = await this.$api.get("/quotes/byid/" + newVal);
      this.quote = response.data;
      this.version = response.data.sha;
      // console.log(this.quote);
      this.lineItems = [];
      let j = 1;
      for (const value of this.quote.part_items) {
        value.id = j;
        this.lineItems.push(value);
        j +=1;
      }

      for (const value of this.quote.work_items) {
        value.id =j;
        this.lineItems.push(value);
        j +=1;
      }
    },
    async initialize () {
      const response = await this.$api.get("/quotes/byid/" + this.$route.params.quoteid, {cache: {maxAge: 30*1000}});
      this.quote = response.data;
      this.version = response.data.sha;
      // console.log(this.quote);
      let j = 1;
      for (const value of this.quote.part_items) {
        value.id = j;
        this.lineItems.push(value);
        j +=1;
      }

      for (const value of this.quote.work_items) {
        value.id =j;
        this.lineItems.push(value);
        j +=1;
      }

      const partsResp = await this.$api.get("/inventory/", {params: {limit: 2000}} );
      this.parts = partsResp.data;
      this.parts = this.parts.sort((a, b) => {
      if (a.Id < b.Id) {
        return 1;
      }
      if (a.Id > b.Id) {
        return -1;
      }
      return 0;
      })

    },
    async saveService () {
        const addObj = Object.assign({}, this.defaultItem);
        addObj.id = this.lineItems.length + 1;
        addObj.kind = 'service';
        addObj.unit = '';
        addObj.description = this.service.Description.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toUpperCase();
        addObj.sku = this.service.FmSku;
        addObj.qty = this.service.Qty;
        addObj.price = this.service.Price;
        this.lineItems.push(addObj);
        this.savePending = true;
        //this.editItem(addObj);
        // this.initialize();
    },
    /* addService() {
       const addObj = Object.assign({}, this.defaultItem);
       addObj.id = this.lineItems.length + 1;
       addObj.Kind = 'service';
       addObj.Unit = '';
       addObj.Description = 'EΞΑΓΩΓΗ ΚΑΙ ΑΝΤΙΚΑΤΑΣΤΑΣΗ ΑΝΤΑΛΛΑΚΤΙΚΩΝ';
       addObj.Sku = '030'
       this.lineItems.unshift(addObj);
    },
    */
    copyItem (item) {
      const addObj = Object.assign({}, item);
      addObj.id = this.lineItems.length + 1;
      this.lineItems.unshift(addObj);
    },
    addAlt (item) {
      if (item.alt) {
          this.editItem(item)
          this.dialog = true
      } else {
        item.alt = Object.assign({}, this.altItem);
        this.editItem(item)
        this.dialog = true
      }
    },
    editItem (item) {
      this.editedIndex = this.lineItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
    },
    deleteItem (item) {
      const index = this.lineItems.indexOf(item);
      confirm('Are you sure you want to delete this item?') && this.lineItems.splice(index, 1);
      this.savePending = true;
    },

    close () {
      setTimeout(() => {
        this.dialog = false ;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300)
    },
    addNew() {
       const addObj = Object.assign({}, this.defaultItem);
       addObj.id = this.lineItems.length + 1;
       this.lineItems.unshift(addObj);
       this.editItem(addObj);
    },
    sumField(items, key) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b[key] || 0), 0);
    },
    sumTotals(items) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b.price*b.qty || 0), 0);
    },
    tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
    save () {
      if (this.editedIndex > -1) {
        // Normalize the description to NFD before saving
        this.editedItem.description = this.editedItem.description.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLocaleUpperCase('GR');
        this.savePending = true;
        // Update the line item with the edited item
        Object.assign(this.lineItems[this.editedIndex], this.editedItem);
      }
      this.close()
    },
    saveOrder(event) {
      const movedItem = this.lineItems.splice(event.oldIndex, 1)[0];
      this.lineItems.splice(event.newIndex, 0, movedItem);
      this.savePending = true;
    },
    unlockQuote () {
        this.lockedQuote = !this.lockedQuote;
    },
    async duplicateQuote() {

      if (this.$refs.form.validate()) {
      let quote = {
        customer: this.quote.customer,
        recipient: this.quote.recipient,
        vehicle: this.quote.vehicle,
        notes: this.quote.notes,
        part_items: filter(this.lineItems, {'kind': 'part'}),
        work_items: filter(this.lineItems, {'kind': 'service'}),
      }

     const resp = await this.$api.post("/quotes/create", quote);
     this.$router.push('/quote/'+resp.data+'/edit');
     this.$router.go();
    }
    },
    commitQuote() {
        this.quote.committed = true;
        this.$api.post("/quotes/commit/"+this.quote.sha, {commit: true}).then((response)=> {
            if (response.data.ok) {
                alert("Η προσφορά έχει καταχωρηθεί.");
            }
        });
    },
    
    async sendQuote() {
      this.sendingQuote = true;
      var response = await this.$api.post("/quotes/email/"+this.quote.sha, null,
       {params: {
          recipient: this.recipient
          }
       }
      );
      this.sendingQuote = false;
      if (response.status == 200) {
           // console.log(response);
             this.snackText = `H προσφορά ${this.quote.quote_id} εστάλη επιτυχώς.`;
          this.snackbar = true;

          } else {
          this.snackText = `H αποστολή απέτυχε!`;
          this.snackbar = true;
          console.log(response);
        }
        
      this.sendMenu = false;
    },
    
    async saveQuote() {

      if (this.$refs.form.validate()) {
      let quote = {
        cid: this.quote.customer.Cid,
        recipient: this.quote.recipient,
        vehicle: this.quote.vehicle,
        quote_id: this.quote.quote_id,
        qdate: this.quote.qdate,
        notes: this.quote.notes,
        parent: this.quote.parent,
        sha: this.quote.sha,
        doc_number: this.quote.doc_number,
        part_items: filter(this.lineItems, {'kind': 'part'}),
        work_items: filter(this.lineItems, {'kind': 'service'}),
      }
      var response = await this.$api.patch("/quotes/"+this.quote.sha, quote)

        if (response.status == 200) {
           // console.log(response);
             this.snackText = `Αποθηκεύτηκε η προσφορά ${this.quote.quote_id}.\nΚωδικός: ${response.data.sha}`;
          this.snackbar = true;
          if (response.data.sha != this.quote.sha) {
           // this.$router.push('/quote/edit/'+response.data.sha);
           this.$router.replace({params: {quoteid: response.data.sha}}, {silent:true})
           this.quote = response.data;
           this.version = this.quote.sha;
           this.savePending = false;
          // this.$router.go();
          }}
        else {
          console.log(response);
        }
      }
    },
    rand() {
      let res = (this.rng() *(26 - 10)) + 10;
      if (res <= 15){
       res *= -1
     }
      return 1 + Math.trunc(res)/100;
    },
    factor (item) {
      if (this.template.startsWith("RIGAS")) return 1;
      return this.factors[this.lineItems.indexOf(item)];
    },
    updateItems () {
        if (!this.template.startsWith("RIGAS")) {
        this.rng = seedrandom(this.quote.quoteid+this.template);
        this.factors = Array.from({length: this.lineItems.length*4 }, () => this.rand());
        }
    },
    async savePart () {
       const addObj = Object.assign({}, this.defaultItem);
       addObj.id = this.lineItems.length + 1;
       addObj.description = this.order.Description;
       addObj.qty = this.partQty;
       addObj.sku = this.order.FmSku;
       addObj.price = this.order.RetailPrice;
       this.lineItems.unshift(addObj);
       this.savePending = true;
       this.editItem(addObj);
       

    },
    customServiceFilter (item, queryText) {
       const desc = item.Description
       const FmSku = item.FmSku
       const searchText = queryText.toUpperCase();
       return desc.includes(searchText) || FmSku.includes(searchText)
    },
    customFilter (item, queryText) {
       const desc = item.Description
       const FmSku = item.FmSku
       const searchText = queryText.toUpperCase();
       return desc.includes(searchText) ||  FmSku.includes(searchText)
      },
    async genQuotes(filetype) {

      if (this.$refs.form.validate()) {
        let lineItems = cloneDeep(this.lineItems);
        if (!this.template.startsWith("RIGAS")) {
          this.rng = seedrandom(this.quote.quoteid+this.template);
          lineItems.forEach(function(item) {
            item.price = item.price * this.rand();
            if (item.kind == 'service') {
              item.price = this.roundUpNearest5or10(item.price);
            }
          }, this);
          
      }

      if (this.margin>0) {
        console.log('MArginalized')
        const markup = 1/(1 - (this.margin / 100));
        lineItems.forEach(function(item) {
          item.price = item.price *markup;
          if (this.roundParts) {
            item.price = this.roundUpNearestPoint(item.price)
          }
           if (item.kind == 'service') {
             item.price = this.roundUpNearest5or10(item.price);
           }
        }, this);
      //  // Calculate the original total value of service items
      //  const originalServiceTotal = this.lineItems
      //    .filter(item => item.kind === 'service')
      //    .reduce((total, item) => total + (item.qty * item.price), 0);

      //  // Calculate the discounted total value of service items
      //  const discountedServiceTotal = (1-this.margin/100) * lineItems
      //    .filter(item => item.kind === 'service')
      //    .reduce((total, item) => total + (item.qty * item.price), 0);

      //  // Calculate the difference
      //  const difference = originalServiceTotal - discountedServiceTotal;

      //  // Get the part items
      //  const partItems = lineItems.filter(item => item.kind === 'part');

      //  // Calculate the adjustment per part item
      //  const adjustmentPerPart = difference / partItems.length;
      //  // Adjust the price of each part item
      //  partItems.forEach(item => {
      //    item.price += adjustmentPerPart / item.qty; // Adjust price per unit
      //    if (this.roundParts) {
      //    item.price = +item.price.toFixed(0);

      //    }
      //    item.price = +item.price.toFixed(2);
      //  });

      }
      let discount = 0;
      if (this.template.endsWith("DSCNT")) {
        discount = this.dscnt/100;
      }
      let quote = {
        cid: this.quote.cid,
        customer: this.quote.customer,
        recipient: this.quote.recipient,
        vehicle: this.quote.vehicle,
        quote_id: this.quote.quote_id,
        qdate: this.quote.qdate,
        sha: this.quote.sha,
        doc_number: this.quote.doc_number,
        parent: this.quote.parent,
        part_items: filter(lineItems, {'kind': 'part'}),
        work_items: filter(lineItems, {'kind': 'service'}),
        discount: discount
      }


      console.log(quote);
      let url = '';
        if (filetype == ".pdf") {
          url = "/quotes/quick/pdf/"+this.template;
        } else {
          url = "/quotes/quick/word/"+this.template;
        }
       let fileName = this.quote.quote_id + "-" + this.template + filetype
      this.$api.post(url, quote, {
        responseType: "blob",
      })
        .then((response) => {
          url = window['URL'].createObjectURL(response.data)
/*          let iframe =  document.createElement('iframe'); //load content in an iframe to print later
          document.body.appendChild(iframe);

          iframe.style.display = 'none';
          iframe.src = url;
          iframe.onload = function() {
            setTimeout(function() {
              iframe.focus();
              iframe.contentWindow.print();
            }, 1);
*/
           var a = document.createElement('a')


          a.href = url
          a.download = fileName;
          a.click()
          a.remove()
          setTimeout(() => window.URL.revokeObjectURL(url), 100)
        })
        .then(() => {
          // alert('File saved succesfully');
        })
        .catch((error) => {
          console.log(error);
        });
      }
    }
  },
}
</script>

<style>
.row-odd {
  background-color: orange;
}
.row-even {
  background-color: "red";
}
</style>
